import SocialLinksPanel from "./SocialLinksPanel";

export default SocialLinksPanel;
